import axios from 'axios';
import { API, authHeaders } from './client';

export const getManualPayments = (token, params) =>
  axios.get(`${API}/manual-payments`, { params, ...authHeaders(token) }).then(r => r.data);

export const createManualPayment = (token, data) =>
  axios.post(`${API}/manual-payments`, data, authHeaders(token)).then(r => r.data);

export const updateManualPayment = (token, id, data) =>
  axios.put(`${API}/manual-payments/${id}`, data, authHeaders(token)).then(r => r.data);

export const toggleManualPaymentPaid = (token, id) =>
  axios.post(`${API}/manual-payments/${id}/toggle-paid`, null, authHeaders(token)).then(r => r.data);

export const deleteManualPayment = (token, id) =>
  axios.delete(`${API}/manual-payments/${id}`, authHeaders(token)).then(r => r.data);
